export default "__VITE_ASSET__OxgPY7jd89vmgHQlmb5h_Q__"